// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__aJXCj","modalFooterButton":"ModalNotes_modalFooterButton__3B4Ij"};